import { render, staticRenderFns } from "./BodyguardServicesPage.vue?vue&type=template&id=10739d19"
import script from "./BodyguardServicesPage.vue?vue&type=script&lang=js"
export * from "./BodyguardServicesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports